import {
  isDef, isObject, toPercentage, toPixel,
} from '@/utils';

const nullableTableValue = (val) => (isDef(val) && val !== '' ? val : '—');

const getCellWidth = (val) => {
  const clampledVal = Math.max(0, val);
  return clampledVal > 1 ? toPixel(clampledVal) : toPercentage(clampledVal);
};

const getDefaultColumnsConfiguration = ({ columnsConfig, data }) => {
  if (!columnsConfig) {
    return !data
      ? []
      : Object.keys(isObject(data[0]) ? data[0] : {}).map((key) => ({
        text: key,
        key,
      }));
  }

  return columnsConfig;
};

export {
  nullableTableValue, getCellWidth, getDefaultColumnsConfiguration, isDef,
};
